import React, { useState } from 'react';
import FontAwesomeIcon from 'src/components/Icon';
import './ExpandableText.scss';

interface ExpandableTextProps {
  text: string;
  characterLimit?: number;
  className?: string;
  disabled?: boolean;
}

const ExpandableText = ({
  text,
  characterLimit = 80,
  className = '',
  disabled = false,
}: ExpandableTextProps) => {
  const [isExpanded, setIsExpanded] = useState<boolean>(false);

  const trimmedText: string = text?.trim() ?? '';
  const needsExpansion: boolean = trimmedText.length > characterLimit;

  const handleToggle = () => {
    if (!disabled) {
      setIsExpanded(!isExpanded);
    }
  };

  return (
    <div
      className={`expandable-text ${className} ${disabled ? 'expandable-text--disabled' : ''}`}
    >
      <div
        className={`expandable-text__content ${
          isExpanded
            ? 'expandable-text__content--expanded'
            : 'expandable-text__content--collapsed'
        }`}
      >
        {trimmedText}
      </div>
      {needsExpansion && (
        <button
          type="button"
          className="expandable-text__toggle"
          onClick={handleToggle}
          disabled={disabled}
          title={isExpanded ? 'Collapse text' : 'Expand text'}
        >
          <FontAwesomeIcon
            glyph={isExpanded ? 'angle-up' : 'angle-down'}
            weight="regular"
            size="small"
          />
        </button>
      )}
    </div>
  );
};

export default ExpandableText;
